import { NgModule } from '@angular/core';
import { NgIconsModule, provideIcons } from '@ng-icons/core';
import {
    lucideChevronDown,
    lucideChevronLeft,
    lucideChevronRight,
    lucideChevronsRight,
    lucideCross,
    lucideInfo,
    lucideTrash2,
    lucideX,
} from '@ng-icons/lucide';
import { BrnPopoverImports } from '@spartan-ng/brain/popover';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { BrnSheetImports } from '@spartan-ng/brain/sheet';
import { HlmAlertImports } from '@spartan-ng/helm/alert';
import { HlmAlertDialogImports } from '@spartan-ng/helm/alert-dialog';
import { HlmBadgeImports } from '@spartan-ng/helm/badge';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCalendarImports } from '@spartan-ng/helm/calendar';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmCheckboxImports } from '@spartan-ng/helm/checkbox';
import { HlmDatePickerImports } from '@spartan-ng/helm/date-picker';
import { HlmDialogImports } from '@spartan-ng/helm/dialog';
import { HlmFormFieldImports } from '@spartan-ng/helm/form-field';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmLabelImports } from '@spartan-ng/helm/label';
import { HlmPopoverImports } from '@spartan-ng/helm/popover';
import { HlmSelectImports } from '@spartan-ng/helm/select';
import { HlmSheetImports } from '@spartan-ng/helm/sheet';
import { HlmToasterImports } from '@spartan-ng/helm/sonner';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';
import { HlmEmptyImports } from 'spartan-ui/ui-empty-helm/src';
import { HlmRadioGroupImports } from 'spartan-ui/ui-radio-group-helm/src';
import { HlmTextareaImports } from 'spartan-ui/ui-textarea-helm/src';

@NgModule({
    imports: [
        HlmButtonImports as unknown as any[],
        HlmCalendarImports as unknown as any[],
        HlmDatePickerImports as unknown as any[],
        HlmLabelImports as unknown as any[],
        BrnSelectImports as unknown as any[],
        HlmSelectImports as unknown as any[],
        HlmFormFieldImports as unknown as any[],
        HlmCardImports as unknown as any[],
        HlmSpinnerImports as unknown as any[],
        BrnPopoverImports as unknown as any[],
        HlmPopoverImports as unknown as any[],
        BrnSheetImports as unknown as any[],
        HlmSheetImports as unknown as any[],
        HlmIconImports as unknown as any[],
        NgIconsModule,
        HlmDialogImports as unknown as any[],
        HlmAlertImports as unknown as any[],
        HlmAlertDialogImports as unknown as any[],
        HlmToasterImports as unknown as any[],
        HlmCheckboxImports as unknown as any[],
        HlmInputImports as unknown as any[],
        HlmTextareaImports as unknown as any[],
        HlmBadgeImports as unknown as any[],
        HlmTooltipImports as unknown as any[],
        HlmEmptyImports as unknown as any[],
        HlmRadioGroupImports as unknown as any[],
    ],
    providers: [
        provideIcons({
            lucideX,
            lucideTrash2,
            lucideChevronLeft,
            lucideChevronRight,
            lucideChevronDown,
            lucideChevronsRight,
            lucideCross,
            lucideInfo,
        }),
    ],
    exports: [
        HlmButtonImports as unknown as any[],
        HlmCalendarImports as unknown as any[],
        HlmDatePickerImports as unknown as any[],
        HlmLabelImports as unknown as any[],
        BrnSelectImports as unknown as any[],
        HlmSelectImports as unknown as any[],
        HlmFormFieldImports as unknown as any[],
        HlmCardImports as unknown as any[],
        HlmSpinnerImports as unknown as any[],
        BrnPopoverImports as unknown as any[],
        HlmPopoverImports as unknown as any[],
        BrnSheetImports as unknown as any[],
        HlmSheetImports as unknown as any[],
        HlmIconImports as unknown as any[],
        NgIconsModule,
        HlmDialogImports as unknown as any[],
        HlmAlertImports as unknown as any[],
        HlmAlertDialogImports as unknown as any[],
        HlmToasterImports as unknown as any[],
        HlmCheckboxImports as unknown as any[],
        HlmInputImports as unknown as any[],
        HlmTextareaImports as unknown as any[],
        HlmBadgeImports as unknown as any[],
        HlmTooltipImports as unknown as any[],
        HlmEmptyImports as unknown as any[],
        HlmRadioGroupImports as unknown as any[],
    ],
})
export class AppSpartanUiModule {}
